import { SelectField } from '#app/components/form/select-field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { RECALL_DRILL_RECENCY_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'
import { type RecallPreparednessFormValues } from '#app/routes/mocra+/_form+/recall-preparedness.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type DrillCadenceValue = RecallPreparednessFormValues['drillRecency']

type Props = {
	readonly resources: SectionResources
	readonly value: DrillCadenceValue
	readonly errors: readonly string[]
	readonly onChange: (value: DrillCadenceValue) => void
}

export function DrillCadenceSection({
	resources,
	value,
	errors,
	onChange,
}: Props) {
	return (
		<Section
			title="Drill cadence"
			description="Show how recently the team rehearsed a mock recall so we can flag refresh needs."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
			childrenClassName="space-y-4"
		>
			<SelectField
				labelProps={{
					children: 'When did you last complete a recall drill?',
				}}
				selectProps={{
					value,
					onChange: (event) => onChange(event.target.value),
				}}
				options={RECALL_DRILL_RECENCY_OPTIONS}
				errors={errors.length > 0 ? [...errors] : undefined}
			/>
		</Section>
	)
}
